<script setup lang="ts">
import useEnvironmentStore from '@/stores/environmentStore'
const env = useEnvironmentStore()

</script>

<template>
  <div class="toolbar">
    <RouterLink :to="{ name: 'home' }"
      ><div class="logo"><img src="/butterfly-icon.png" /></div
    ></RouterLink>
    <div class="title">
      <h3>{{ $t(env.title) }}</h3>
    </div>
    <div class="profile">
      <RouterLink :to="{ name: 'profile' }"
        ><span class="profile-ico"><font-awesome-icon :icon="['fas', 'user']" size="xl" /></span
      ></RouterLink>
    </div>
  </div>
</template>

<style scoped>
.toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.toolbar div {
  min-width: 80px;
  padding: 8px;
}

div.title,
div.profile {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.profile-ico {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-content: flex-end;
  color: white;
}

img {
  max-width: 36px;
  min-width: 36px;
  height: auto;
}
</style>
